import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class MenuGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const fullUrl = '/' + route.pathFromRoot
      .map(r => r.url.map(seg => seg.path).join('/'))
      .filter(p => !!p)
      .join('/');

    const menu = this.authService.getMenu();
    const tienePermiso = this.tienePermisoRuta(menu, fullUrl);

    if (!tienePermiso) {
      console.warn('⛔ Ruta sin permiso:', fullUrl);
      return this.router.parseUrl('/home');
    }

    return true;
  }

  private tienePermisoRuta(menu: any[], url: string): boolean {
    for (const item of menu) {
      if (item.path === url) return true;
      if (item.children?.length > 0 && this.tienePermisoRuta(item.children, url)) {
        return true;
      }
    }
    return false;
  }
}
